<template>
  <section class="av-doc" aria-labelledby="avaluos-doc-title">
    <div class="av-doc__media">
      <img class="av-doc__image" :src="image" alt="Sala de una vivienda con mobiliario y plantas">
    </div>

    <div class="av-doc__content">
      <span class="av-doc__tag">Documentación</span>

      <div class="av-doc__text">
        <h2 id="avaluos-doc-title" class="av-doc__title">Lo que necesitarás para tu proceso</h2>
        <p class="wd-body">
          Reúne esta documentación para que tu proceso avance <br class="br-d">sin contratiempos.
        </p>
      </div>

      <ul class="av-doc__items">
        <li v-for="item in items" :key="item.icon" class="av-doc__item">
          <img :src="item.icon" alt="" aria-hidden="true">
          <span class="wd-body" v-html="item.text" />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import image from '../../../assets/avaluos-figma/documentacion.jpg'
import documentIcon from '../../../assets/avaluos-figma/doc-1.svg'
import paymentIcon from '../../../assets/avaluos-figma/doc-2.svg'
import propertyIcon from '../../../assets/avaluos-figma/doc-3.svg'

const items = [
  { icon: documentIcon, text: 'Documentos de HIR Casa: Carta autorización y solicitud (proporcionadas por HIR Casa)' },
  { icon: paymentIcon, text: 'Pago del trámite: Previamente <br class="br-tm">te enviamos tu cotización' },
  { icon: propertyIcon, text: 'Del inmueble: Boleta de agua, predial y título de propiedad <br>del inmueble a valuar' }
]
</script>

<style scoped>
.av-doc { display: flex; align-items: stretch; gap: var(--ds-space-5); }

/* La imagen se posiciona sobre el contenedor para que su alto intrínseco no estire la sección */
.av-doc__media { position: relative; flex: 0 0 370px; min-width: 0; min-height: 454px; border-radius: 24px; overflow: hidden; }
.av-doc__image { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; object-position: 0 50%; }

.av-doc__content {
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--ds-space-5);
  min-width: 0;
}

.av-doc__tag {
  display: inline-flex;
  align-items: center;
  padding: var(--ds-space-3);
  border-radius: 9999px;
  background: var(--ds-tag-orange-fill);
  color: var(--ds-tag-orange-text);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
}

.av-doc__text { display: flex; flex-direction: column; gap: var(--ds-space-3); width: 100%; }
.av-doc__title {
  margin: 0;
  color: var(--ds-purple-900);
  font-family: var(--ds-font-family-bebas);
  font-size: 32px;
  font-weight: 700;
  line-height: normal;
}

.av-doc__items { display: flex; flex-direction: column; gap: var(--ds-space-6); width: 100%; margin: 0; padding: 0; list-style: none; }
.av-doc__item { display: flex; align-items: center; gap: var(--ds-space-3); min-height: 40px; }
.av-doc__item img { flex: 0 0 40px; width: 40px; height: 40px; }

@media (max-width: 1024px) {
  .av-doc__media { flex-basis: 340px; min-height: 460px; }
}

@media (max-width: 599px) {
  .av-doc { flex-direction: column; padding: var(--ds-space-5) 0; }
  .av-doc__media { flex: none; width: 100%; min-height: 0; aspect-ratio: 1 / 1; }
  .av-doc__content { flex: none; justify-content: flex-start; width: 100%; padding: 0 var(--ds-space-3); box-sizing: border-box; }
}
</style>
